export default "__VITE_ASSET__c05043c8__"